import { Col, Form, InputGroup, Row } from 'react-bootstrap'
import * as Yup from 'yup'

type Values = {
  columns: number
  sizeInColumns: number
  rows: number
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  isSettingWritable: boolean
  rowIndex: number
}

const _HorizontalHeadingMarginSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSettingWritable,
  rowIndex
}: Props) => {
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={2}>
        {values.columns}段横見出し（{values.sizeInColumns}段相当）
      </Col>
      <Col>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id='rowsInput'
            type='number'
            name='rows'
            value={values.rows || ''}
            onChange={(e) => {
              handleChange(e)
              handleSubmit(values)
            }}
            onBlur={handleBlur}
            isInvalid={!!(touched.rows && errors.rows)}
            disabled={!isSettingWritable}
          />
          <InputGroup.Text>行取り</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.rows}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const HorizontalHeadingMarginSettingForm = Object.assign(_HorizontalHeadingMarginSettingForm, {
  schema: Yup.object().shape({
    rows: Yup.number().min(1).required()
  })
})
